import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  saveTaskCallback,
  updateTaskStep3Callback
} from 'Pages/Task/recoil/callbacks/callbacks'
import { pageState, step3IsEnabledState } from 'Pages/Task/recoil/state/page'
import { taskState } from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import BoxFrequencySend from './BoxFrequencySend'
import BoxSelectRecipients from './BoxSelectRecipients'

const TaskStep3 = () => {
  const intl = useIntl()
  const { saveTask: saveTaskOrChange } = useRecoilValue(taskState)

  const step3IsEnabled = useRecoilValue(step3IsEnabledState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const updateTaskStep3 = useRecoilCallback(updateTaskStep3Callback, [])
  const { idTask } = useRecoilValue(pageState)
  const saveTask = useRecoilCallback(saveTaskCallback, [])

  const handleBack = () => {
    changeWizardStep(2)
  }

  const handleConfirm = () => {
    updateTaskStep3()
    if (idTask === 0) {
      changeWizardStep(4)
    }
  }

  useEffect(() => {
    if (saveTaskOrChange && idTask > 0) {
      saveTask(false)
    }
  }, [saveTaskOrChange])

  return (
    <>
      <BoxSelectRecipients />
      <BoxFrequencySend />
      <Flex justifyContent='space-between'>
        <Button
          disabled={idTask > 0 && !step3IsEnabled}
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={() => handleBack()}
          data-mu-test={idTask > 0 ? 'task-3-btn-back' : 'task-3-btn-back'}
        >
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>

        <Button
          data-mu-test={idTask > 0 ? 'task-3-btn-update' : 'task-3-btn-save'}
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={() => handleConfirm()}
          disabled={!step3IsEnabled}
        >
          {idTask > 0
            ? intl.formatMessage({ id: 'Load.Task.SaveTask' })
            : intl.formatMessage({ id: 'Load.Task.Next' })}
        </Button>
      </Flex>
    </>
  )
}

export default TaskStep3
